import { Inject, Injectable, Injector } from '@angular/core';

import { map, Observable, of, shareReplay, tap } from 'rxjs';
import {
  ClientePostRequest,
  ClienteRequest,
} from '../../../models/cliente.models';
import {
  ClientBarRequest,
  ClientBarResponse,
} from '../../../models/client-bar.models';
import { PaginatorResponse } from '../../../models/login.models';
import { UtilsBaseApiService } from '@brunsker/libs/core/utils/base-api';
import {
  AllVendedoresResponse,
  ClienteResponse,
  VendedoresResponse,
} from '@brunsker/libs/portal-do-vendedor/utils/portal-vendedor-api';
import {
  Environment,
  ENVIRONMENT_TOKEN,
} from '@brunsker/libs/core/utils/http-log-interceptor/src';
import { VendedorSelectService } from '../vendedor-service/vendedor-service.service';

@Injectable({
  providedIn: 'root',
})
export class NewApiClienteService extends UtilsBaseApiService<NewApiClienteService> {
  readonly VENDEDOR_EXTENSION = 'vendedor';
  readonly VENDEDORES_EXTENSION = 'vendedores';
  readonly GET_CLIENTES_EXTENSION = 'getClientes';
  readonly LIMITE_EXTENSION = 'limite_de_credito';
  readonly GET_BY_ID = 'get-by-id';
  readonly CLIENT_BAR_DATA_EXTENSION = 'dadosClienteBar';
  readonly IMAGE = 'image';
  clientes!: PaginatorResponse<ClienteResponse>;
  selectOptions!: PaginatorResponse<ClienteResponse>;
  constructor(
    @Inject(ENVIRONMENT_TOKEN) readonly environment: Environment,
    override readonly injector: Injector,
    private readonly vendedorSelectService: VendedorSelectService,
  ) {
    super('cliente', injector, environment.BASE_API_URL);
  }

  getVendedorById(id: number): Observable<VendedoresResponse[]> {
    return this.httpClient.get<VendedoresResponse[]>(
      `${this.BASE_URL}${this.CONTEXT}/${this.VENDEDOR_EXTENSION}?${this.getQueryString({ id_vendedor: id })}`,
    );
  }

  getAllVendedores(idFunc: number): Observable<AllVendedoresResponse[]> {
    return this.httpClient.get<AllVendedoresResponse[]>(
      `${this.BASE_URL}${this.CONTEXT}/${this.VENDEDORES_EXTENSION}?${this.getQueryString({ idFunc })}`,
    );
  }

  createCliente = (cliente: ClientePostRequest) =>
    this.create<ClientePostRequest, ClienteResponse[]>(cliente);

  getClientes(clienteRequest: ClienteRequest) {
    if (clienteRequest.CodUsur === 0) {
      clienteRequest['CodUsur'] = this.vendedorSelectService.vendedorActiv();
    }
    const QUERY_STRING = this.getQueryString(clienteRequest);
    if (!clienteRequest.Nome && this.clientes) {
      return of(this.clientes);
    }
    return this.httpClient
      .get<
        PaginatorResponse<ClienteResponse>
      >(`${this.BASE_URL}${this.CONTEXT}?${QUERY_STRING}`)
      .pipe(
        tap((response) => {
          if (!clienteRequest.Nome && !this.clientes) {
            this.clientes = response;
            return;
          }
          this.clientes.data.push(...response.data);
        }),
        shareReplay(1),
      );
  }
  postImage(imageData: FormData) {
    return this.httpClient.post<null>(
      `${this.BASE_URL}${this.CONTEXT}/${this.IMAGE}`,
      imageData,
    );
  }

  getClienteForOptions(nome: string) {
    return this.getClientes({ Nome: nome, length: 30, index: 0 }).pipe(
      map((response) => {
        this.clientes = response;
        return response.data;
      }),
    );
  }

  getLimite(clienteID: string | number) {
    return this.httpClient.get<number>(
      `${this.BASE_URL}${this.CONTEXT}/${this.LIMITE_EXTENSION}?${this.getQueryString({ codigoCliente: clienteID, clienteID })}`,
    );
  }

  getClienteById(id: string | number): Observable<ClienteResponse> {
    return this.httpClient.get<ClienteResponse>(
      `${this.BASE_URL}${this.CONTEXT}/${this.GET_BY_ID}?${this.getQueryString({ id })}`,
    );
  }

  getClientBarData(request: ClientBarRequest) {
    return this.httpClient.post<ClientBarResponse>(
      `${this.BASE_URL}${this.CONTEXT}/${this.CLIENT_BAR_DATA_EXTENSION}`,
      request,
    );
  }
}
